import { ProfileScreenTabs } from "app/utils/const";

const FetchTabContentHelper = (tabType: string, data: Record<string, any>) => {
  switch (tabType) {
    case ProfileScreenTabs.PERSONAL_DETAILS:
      data.loadAccount();
      break;

    case ProfileScreenTabs.SECURITY:
      data.loadAccount();
      break;

    case ProfileScreenTabs.PREFERENCES:
      data.loadAccount();
      break;

    default:
      return;
  }
};

export default FetchTabContentHelper;
